import Vue from 'vue';
import MapComponent from '@app/components/Map.vue';
import { EventTracking, EventType } from '@app/tracking';
export default Vue.extend({
    components: {
        MapComponent: MapComponent
    },
    props: {
        block: Object
    },
    methods: {
        markerClicked: function () {
            if (this.block.localized.url) {
                EventTracking.dispatch(EventType.Track, {
                    category: 'Map',
                    action: 'click',
                    label: this.block.localized.address
                });
                window.open(this.block.localized.url, '_blank');
            }
        }
    }
});
